module.exports = __webpack_public_path__ + "img/sun_white.ed46435b.svg";